import { render, staticRenderFns } from "./UserReport.vue?vue&type=template&id=be17f6c8&scoped=true&"
import script from "./UserReport.vue?vue&type=script&lang=js&"
export * from "./UserReport.vue?vue&type=script&lang=js&"
import style0 from "./UserReport.vue?vue&type=style&index=0&id=be17f6c8&scoped=true&lang=css&"
import style1 from "./UserReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be17f6c8",
  null
  
)

export default component.exports